var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmartidIcon = function SvgSmartidIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 0c-1.059 0-2.121.105-3.157.312a.916.916 0 0 0-.736.898v20.981a.917.917 0 0 0 1.833 0V1.982c.679-.098 1.37-.147 2.058-.147C23.81 1.835 30.166 8.19 30.166 16c0 4.487-2.163 8.757-5.782 11.42a.916.916 0 1 0 1.087 1.476A16.07 16.07 0 0 0 32 16C32 7.177 24.822 0 16 0m2.977 11.19a1.156 1.156 0 1 0 0-2.31 1.156 1.156 0 0 0 0 2.31m-.917 5.684c0-.506.411-.917.917-.917l.001.004c.506 0 .917.409.917.916V30.79a.92.92 0 0 1-.737.9c-1.032.205-2.094.31-3.156.31-8.823 0-16-7.177-16-16 0-5.068 2.442-9.887 6.532-12.895A.917.917 0 0 1 7.62 4.581a14.23 14.23 0 0 0-5.786 11.417c0 7.812 6.356 14.166 14.168 14.166.69 0 1.38-.05 2.058-.148z",
    clipRule: "evenodd"
  })));
};
export default SvgSmartidIcon;